import { useCallback, useEffect, useState } from 'react';

export default function useBreakpoint(width = 1024): boolean {
  const [under, setUnder] = useState<boolean>(false);

  const handleResize = useCallback(() => {
    const windowWidth = window.innerWidth;
    const isUnder = windowWidth < width;
    if (under === isUnder) return;
    setUnder(isUnder);
  }, [under, width]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return under;
}
